export { default } from '@ember-data/debug/setup';
